<ng-container *ngIf="count">
  <div class="full-height layout-row" (click)="onClick.emit();$event.stopPropagation();">
    <bringoz-icon iconName="relation"
                  fill="#484848"
                  ngbTooltip="{{count}} {{'Linked tasks' | translate}}"></bringoz-icon>
    <span class="md-tiny">{{ count }}</span>
  </div>
</ng-container>
